export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page">
      <section className="container-px pt-16 md:pt-24 pb-16">
        <div className="max-w-3xl">
          <div className="overline mb-6">Legal</div>
          <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tight text-ink leading-[1.05]">
            Privacy Policy
          </h1>
          <p className="mt-6 text-lg text-ink-soft leading-relaxed">
            Last Updated: July 11, 2026. This policy describes how Oswal Sabha Professional Forum ("we", "us", or "our") collects, uses, and protects your information when you visit and use our website (ospfudr.com).
          </p>
        </div>
      </section>

      <section className="container-px pb-24">
        <div className="max-w-3xl card-premium space-y-8">
          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">1. Information We Collect</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              We collect information you provide directly to us when you apply for membership, create a directory profile, register for events, or contact us. This may include your name, email address, phone number, city, professional details, business descriptions, social links, and profile photos.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">2. How We Use Your Information</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              We use the collected information to process and manage your membership, display your professional profile in our member directory, send community updates, process event registrations, and keep the platform secure. We do not sell or lease your personal information to third parties.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">3. Cookies and Advertising</h2>
            <p className="text-ink-soft leading-relaxed text-sm mb-3">
              Our website uses cookies to enhance your browsing experience, store preferences, and analyze traffic. By using our website, you consent to our use of cookies.
            </p>
            <p className="text-ink-soft leading-relaxed text-sm">
              <strong>Google AdSense & Third-Party Advertising:</strong> Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of advertising cookies enables it and its partners to serve ads to our users based on their visit to our site or other sites on the Internet. Users may opt out of personalized advertising by visiting <a href="https://settings.google.com/ads" target="_blank" rel="noreferrer" className="text-orange-600 hover:underline">Google Ad Settings</a> or by visiting <a href="https://aboutads.info" target="_blank" rel="noreferrer" className="text-orange-600 hover:underline">aboutads.info</a>.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">4. Security</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              We implement industry-standard technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">5. Third-Party Links</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              Our site may contain links to external websites, including member social profiles, external galleries, and partner services. We are not responsible for the privacy practices or content of these third-party websites.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">6. Contact Us</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              If you have any questions or concerns about this Privacy Policy, please contact us via email at <a href="mailto:oswalsabhaprofessionalforum@gmail.com" className="text-orange-600 hover:underline">oswalsabhaprofessionalforum@gmail.com</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
